import analytics from '../analytics';

export default class HedinDriveSimplifiedSearch {

  #element;

  #dom = {};

  constructor(element) {
    this.#element = element;
    this.#dom.submitBtn = element.querySelector('button[type="submit"]')
    this.#dom.rangeSlider = element.querySelector('.js-range-slider');
    this.#dom.categoryFilters = element.querySelectorAll('.js-category-filter');
    this.#dom.rangeFilters = element.querySelectorAll('.min_slider, .max_slider');
    this.#bindEvents();
  }

  /**
   * Bind the events
   * @private
   */
  #bindEvents() {
    this.#element.addEventListener('change', this.#onChange.bind(this));
    this.#element.addEventListener('submit', this.#onSubmit.bind(this));

    window.multiselects['brands[]']?.addCallback({ onValueChange: this.#brandSelectChange.bind(this) });
    window.multiselects['body_type[]']?.addCallback({ onValueChange: this.#pushMultiselectAnalytics.bind(this) });
    window.multiselects['fuel[]']?.addCallback({ onValueChange: this.#pushMultiselectAnalytics.bind(this) });

    this.#dom.rangeFilters.forEach((filter) => {
      filter.addEventListener('change', (event) => {
        const min = this.#dom.rangeFilters[0].value;
        const max = this.#dom.rangeFilters[1].value;

        analytics.pushToDataLayer({
          event: 'UI Interaction',
          interaction: {
            elementName: 'UI - Hedin Drive - Hinta',
            selectedItem: `${min}-${max}`,
            type: 'change',
          }
        });
      });
    });

    this.#dom.categoryFilters.forEach((filterContainer) => {
      const input = filterContainer.querySelector('input[type="radio"]');

      if (input?.dataset['uncheckable'] === 'true') {
        const label = filterContainer.querySelector('label');

        // Unselect clicked category radio filter if it's already selected
        label.addEventListener('click', (event) => {
          let checked = true;

          if (input.checked) {
            event.preventDefault();
            checked = false;
            input.checked = checked;
          }

          const label = filterContainer.querySelector('label');
          const labelText = label ? label.textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim() : '';

          analytics.pushToDataLayer({
            event: 'UI Interaction',
            interaction: {
              elementName: `UI - Hedin Drive - car_type | ${labelText}`,
              selectedItem: input.name,
              type: 'click',
              textInputValue: checked,
            }
          });
        });
      }
    });
  }

  #pushMultiselectAnalytics(multiselect) {
    analytics.pushToDataLayer({
      event: 'UI Interaction',
      interaction: {
        elementName: `UI - Hedin Drive - ${multiselect.selectDetails.defaultCaption}`,
        selectedItem: multiselect.value,
        type: 'change',
      }
    });
  }

  #brandSelectChange(brandSelect) {
    this.#pushMultiselectAnalytics(brandSelect);
    this.#showModels();
  }

  /**
   * Called when a form's value changes
   * @param {Event} event event object
   */
  #onChange(event) {
    // this.#dom.submitBtn.disabled = this.isSubmitButtonDisabled();
  }

  /**
   * Is the submit button disabled or not.
   * @returns {boolean}
   */
  isSubmitButtonDisabled() {
    const minMax = this.#dom.rangeSlider.rangeSlider.value;
    return !(this.#element['car-type']?.value && minMax.min >= 0 && minMax.max >= 0);
  }

  /**
   * Handle the form submit event
   * @param {Event} event - The submit event
   * @private
   */
  #onSubmit(event) {
    event.preventDefault();

    const formData = new FormData(this.#element);
    const params = new URLSearchParams();

    for (const [key, value] of formData.entries()) {
      if (value) {
        params.append(key, value);
      }
    }

    window.location.href = `${this.#element.action}?${params.toString()}`;
  }

  /**
   * Filters car models multiselect option groups depending what brands are selected.
   */
  #showModels() {

    const allBrands = window.multiselects['models[]']?.listAllGroupNames();
    const selectedBrands = window.multiselects['brands[]']?.getValue().filter( brand => brand !== '');

    if (Array.isArray(selectedBrands)) {
      if (selectedBrands.length === 0) {
        window.multiselects['models[]']?.unSelectAll(false);
        window.multiselects['models[]']?.disableMultiselect();
      } else {
        window.multiselects['models[]']?.enableMultiselect();
      }
    }

    allBrands?.forEach(brandSlug => {
      const show = selectedBrands.includes(brandSlug);
      window.multiselects['models[]'].toggleOptionGroup(brandSlug, show);
    });

  }

  /**
   * Initialize the simplified search
   */
  static init() {
    document.querySelectorAll('form.js-hedindrive-simplified-search').forEach((form) => {
      new HedinDriveSimplifiedSearch(form);
    });
  }
}
